module.exports = __webpack_public_path__ + "img/qr-djcx.9fd239b1.png";